import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    const selectedValue = this.element.value;
    
    if (selectedValue && selectedValue !== "") {
      if (this.data.has("targetDistrictSelector")) {
        this.filterDistrict({ target: this.element });
      } else if (this.data.has("targetSchoolSelector")) {
        this.filterSchool({ target: this.element });
      }
    }
  }

  filterSelect(data, elementId, selectedValue = null) {
    let options = data.map(d => `<option value="${d.id}">${d.name}</option>`);
    let html = `<option value="">Select ${elementId.replace(/#\w+_(\w+)_ids?$/, "$1").replace("_", " ")}</option>${options.join("")}`;
    
    const $element = $(elementId);
    $element
      .prop('disabled', false)
      .find('option')
      .remove()
      .end()
      .append(html);
    if (selectedValue && selectedValue !== "") {
      $element.val(selectedValue);
    }

    document.querySelector(elementId)?.dispatchEvent(new Event("change"));
  }

  filterSchool(event) {
    const targetSelector = this.data.get("targetSchoolSelector");
    const url = this.data.get("schoolUrl");
    const currentValue = document.querySelector(targetSelector)?.value;
    
    $.ajax({
      url: url,
      data: "district_ids=" + Array.from(event.target.selectedOptions).map(option => option.value)
    }).done((data) => this.filterSelect(data, targetSelector, currentValue));
  }

  filterDistrict(event) {
    const targetSelector = this.data.get("targetDistrictSelector");
    const url = this.data.get("districtUrl");
    const currentValue = document.querySelector(targetSelector)?.value;
    
    $.ajax({
      url: url,
      data: { state_ids: Array.from(event.target.selectedOptions).map(option => option.value).join(",") }
    }).done((data) => this.filterSelect(data, targetSelector, currentValue));
  }
}